import { render, staticRenderFns } from "./PaginaAdminCreadoresDepartamentales.vue?vue&type=template&id=0cfa5d14&lang=es"
import script from "./PaginaAdminCreadoresDepartamentales.vue?vue&type=script&lang=js"
export * from "./PaginaAdminCreadoresDepartamentales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports